/* ==========================================================================
   DIVA LONDON — Coming Soon Landing Page JS
   Ported from diva-london-preview-v3.9.html
   ========================================================================== */

(function () {
  'use strict';

  var progress = document.getElementById('csProgress');
  var scrollPrompt = document.getElementById('csScrollPrompt');
  var topmark = document.getElementById('csTopmark');
  var heroSection = document.getElementById('csHero');
  var beats = document.querySelectorAll('.cs-beat');
  var beatImages = document.querySelectorAll('.cs-beat-image');

  if (!heroSection) return;

  /* ===== SCROLL HANDLER ===== */
  function update() {
    var scrollY = window.scrollY;
    var docH = document.documentElement.scrollHeight - window.innerHeight;
    var winH = window.innerHeight;

    if (progress) {
      progress.style.width = ((scrollY / docH) * 100) + '%';
    }

    if (scrollPrompt) {
      var heroFadeRange2 = winH * 0.6;
      var fadeProgress2 = Math.min(1, scrollY / heroFadeRange2);
      scrollPrompt.style.opacity = Math.max(0, 1 - fadeProgress2 * 2);
    }

    /* Show top brand mark after hero */
    if (topmark) {
      if (scrollY > winH * 0.7) {
        topmark.classList.add('visible');
      } else {
        topmark.classList.remove('visible');
      }
    }

    /* Beats — fade in copy and image when in view */
    beats.forEach(function (beat) {
      var rect = beat.getBoundingClientRect();
      var beatCentre = rect.top + rect.height / 2;
      var copy = beat.querySelector('.cs-beat-copy');
      var image = beat.querySelector('.cs-beat-image');

      if (beatCentre < winH * 0.85 && rect.bottom > 0) {
        if (copy) copy.classList.add('visible');
        if (image) image.classList.add('visible');
      }
    });

    /* Parallax on images */
    beatImages.forEach(function (beatImage) {
      var rect = beatImage.getBoundingClientRect();
      var winMid = winH / 2;
      var imageMid = rect.top + rect.height / 2;
      var offset = (winMid - imageMid) * 0.08;
      var inner = beatImage.querySelector('.cs-beat-image-inner');
      if (inner && !inner.classList.contains('cs-img1')) {
        inner.style.transform = 'scale(1.1) translateY(' + offset + 'px)';
      } else if (inner && inner.classList.contains('cs-img1')) {
        inner.style.transform = 'scale(1.25) translateY(' + offset + 'px)';
      }
    });
  }

  var ticking = false;
  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(function () {
        update();
        ticking = false;
      });
      ticking = true;
    }
  });
  update();

  /* ===== WORD CYCLE (with visibility gating) ===== */
  var wordCycle = document.getElementById('csWordCycle');
  if (wordCycle && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var words = wordCycle.querySelectorAll('.cs-cycle-word');
    var currentIndex = 0;
    var cycleInterval = null;

    var advanceWord = function () {
      var current = words[currentIndex];
      current.classList.remove('active');
      current.classList.add('exiting');

      currentIndex = (currentIndex + 1) % words.length;
      var next = words[currentIndex];

      setTimeout(function () {
        current.classList.remove('exiting');
        next.classList.add('active');
      }, 80);
    };

    var startCycle = function () {
      if (cycleInterval) return;
      cycleInterval = setInterval(advanceWord, 2500);
    };

    var stopCycle = function () {
      if (!cycleInterval) return;
      clearInterval(cycleInterval);
      cycleInterval = null;
    };

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          startCycle();
        } else {
          stopCycle();
        }
      });
    }, { threshold: 0.4 });

    var closestBeat = wordCycle.closest('.cs-beat');
    if (closestBeat) observer.observe(closestBeat);
  }

  /* ===== COUNTDOWN (single-line, day resolution) ===== */
  (function initCountdown() {
    // Launch-day flourish: when true and days <= 2, swap in the full HH:MM:SS timer.
    // Default off — keep the line minimal until the flag is flipped by design.
    var LAUNCH_DAY_FLOURISH = false;

    var countdownEl = document.getElementById('csCountdown');
    var cdLine = document.getElementById('csCdLine');
    if (!countdownEl || !cdLine) return;

    var launchStr = countdownEl.getAttribute('data-launch');
    var launchDate = new Date(2026, 5, 1, 0, 0, 0).getTime();
    if (launchStr) {
      var parsed = new Date(launchStr);
      if (!isNaN(parsed.getTime())) launchDate = parsed.getTime();
    }

    countdownEl.classList.add('js-ready');

    var tickInterval = null;

    function render() {
      var diff = launchDate - Date.now();

      if (diff <= 0) {
        countdownEl.classList.add('launched');
        if (tickInterval) { clearInterval(tickInterval); tickInterval = null; }
        return;
      }

      var days = Math.floor(diff / 86400000);
      var label;
      if (days === 0)      label = 'Doors open today';
      else if (days === 1) label = 'Doors open tomorrow';
      else                 label = 'Doors open in ' + days + ' days';

      // Launch-day flourish reserved for a later flag flip.
      if (LAUNCH_DAY_FLOURISH && days <= 2) {
        var hours   = Math.floor((diff / 3600000) % 24);
        var minutes = Math.floor((diff / 60000) % 60);
        var seconds = Math.floor((diff / 1000) % 60);
        var pad = function (n) { return String(n).padStart(2, '0'); };
        label = days + ' days · ' + pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
      }

      cdLine.textContent = label;
    }

    function start() {
      if (tickInterval) return;
      render();
      // Display only changes at day boundaries — one hour is ample.
      tickInterval = setInterval(render, 3600000);
    }

    function stop() {
      if (tickInterval) { clearInterval(tickInterval); tickInterval = null; }
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });

    start();
  })();

  /* ===== LOADER DISMISSAL ===== */
  var loader = document.getElementById('csLoader');
  var revealPage = function () {
    if (loader) loader.classList.add('done');
    document.body.classList.add('cs-loaded');
  };

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    revealPage();
  } else {
    window.addEventListener('load', function () {
      setTimeout(revealPage, 2000);
    });
    if (document.readyState === 'complete') {
      setTimeout(revealPage, 2000);
    }
  }

})();
